import React, { useState } from 'react';
import { Puzzle } from 'lucide-react';
import { useMetadata } from '../../context/MetadataContext';
import { useGameState } from '../../context/GameStateContext';
import { formatDateUppercase } from '../../utils/formatDate';
import { useShareCreatedPuzzle } from '../../hooks/useShareCreatedPuzzle';
import ShareModal from '../ShareModal';
import styles from './CreatedPuzzleDetail.module.css';
import { Pencil, Share2 } from 'lucide-react';

const CreatedPuzzleDetail = ({ puzzleData, onClose }) => {
  const { getText } = useMetadata();
  const { editCreatedPuzzle } = useGameState();
  const { isLoadingShare, sharePuzzle } = useShareCreatedPuzzle();
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [shareUrl, setShareUrl] = useState('');

  const handleShareClick = async () => {
    await sharePuzzle(puzzleData, (shareCode) => {
      // Construct the share URL for the frontend application using query parameters
      const shareUrl = `${window.location.origin}?share_code=${shareCode}`;
      setShareUrl(shareUrl);
      setShareModalOpen(true);
    });
  };

  const handleEditClick = async () => {
    if (puzzleData && puzzleData.puzzle_key) {
      try {
        await editCreatedPuzzle(puzzleData.puzzle_key);
        // Close the modal after successful edit call
        onClose();
      } catch (error) {
        // Error handling is done in the GameStateContext
        console.error('Failed to edit puzzle:', error);
      }
    } else {
      console.error('No puzzle key found for puzzle');
    }
  };

  

  if (!puzzleData) {
    return (
      <div className={styles.loading}>
        {getText('common_text.loading') || 'Loading...'}
      </div>
    );
  }

  return (
    <div className={styles.puzzleDetailContainer}>
      
      <div className={styles.puzzleCard}>
     
        <div className={styles.puzzleInfo}>
          <h3 className={styles.puzzleTitle}>
            {puzzleData.style.charAt(0).toUpperCase() + puzzleData.style.slice(1)} Puzzle
          </h3>
          
          <div className={styles.detailsGrid}>
            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>
                {getText('common_text.style')}
              </span>
              <span className={styles.detailValue}>
                {puzzleData.style.charAt(0).toUpperCase() + puzzleData.style.slice(1)}
              </span>
            </div>
            
            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>
                {getText('common_text.size')}
              </span>
              <span className={styles.detailValue}>{puzzleData.size}x{puzzleData.size}</span>
            </div>
            
            {puzzleData.submitted_ts && (<div className={styles.detailRow}>
              <span className={styles.detailLabel}>
                {getText('common_text.submitted')}
              </span>
              <span className={styles.detailValue}>
                {formatDateUppercase(puzzleData.submitted_ts)}
              </span>
            </div>
            )}
            
            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>
                {getText('common_text.status')}
              </span>
              <span className={styles.detailValue}>
                {puzzleData.status.charAt(0).toUpperCase() + puzzleData.status.slice(1)}
              </span>
            </div>

            {puzzleData.accepted_ts && (<div className={styles.detailRow}>
              <span className={styles.detailLabel}>
                {getText('common_text.accepted')}
              </span>
              <span className={styles.detailValue}>
                {formatDateUppercase(puzzleData.accepted_ts)}
              </span>
            </div>
            )}

            
            {puzzleData.reason && (
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>
                  {getText('create.reason') }
                </span>
                <span className={styles.detailValue}>{puzzleData.reason}</span>
              </div>
            )}
            
          </div>
        </div>
      </div>

      <div className="actionButtonContainer">
      {puzzleData.accepted_ts && (<button 
          className="iconButton primaryButton"
          onClick={handleShareClick}
          title={getText('create.share_puzzle')}
          aria-label={getText('create.share_puzzle')}
        >
          <Share2 className="buttonIcon" />
        </button>
      )}
      {puzzleData.submitted_ts && (<button 
          className="iconButton primaryButton"
          onClick={handleEditClick}
          title={getText('create.edit_puzzle')}
          aria-label={getText('create.edit_puzzle')}
        >
          <Pencil className="buttonIcon" />
        </button>
      )}
      </div>

      <ShareModal
        isOpen={shareModalOpen}
        onClose={() => setShareModalOpen(false)}
        shareUrl={shareUrl}
        modalType="share"
      />
    </div>
  );
};

export default CreatedPuzzleDetail;